export function clonePath(path) {
  return path.map(function (x) {
    return Array.isArray(x) ? [].concat(x) : x;
  });
}